import { Path } from 'react-hook-form';

import { FormData } from './types';

// API parameter names, as an error's `details` names them, and the fields they're entered in.
const PARAM_FIELDS: Record<string, Path<FormData>> = {
  routing_number: 'routingNumber',
  account_number: 'accountNumber',
  account_type: 'accountType',
  description: 'description',
  local_bank_name: 'localBankName',
  local_bank_code: 'localBankCode',
  local_account_number: 'localAccountNumber',
  local_bank_country_code: 'localBankCountryCode',
  name: 'name',
  email: 'email',
  phone: 'phone',
  legal_type: 'legalType',
  legal_id: 'legalId',
  line_1: 'address.line1',
  line_2: 'address.line2',
  city: 'address.city',
  state: 'address.state',
  postal_code: 'address.postalCode',
  country_code: 'address.countryCode',
};

// Rejections that are about one field without naming it, e.g. an IBAN the bank doesn't recognize.
const CODE_FIELDS: Record<string, Path<FormData>> = {
  bank_account_not_found: 'accountNumber',
  routing_number_not_found: 'routingNumber',
};

/** The field a rejected create is about, so it can be marked along with the message. */
export const fieldForApiError = (error: unknown): Path<FormData> | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const { code, details } = error as { code?: string; details?: Record<string, string> | null };
  const param = details?.field ?? Object.keys(details ?? {}).find((key) => key in PARAM_FIELDS);
  return (param && PARAM_FIELDS[param]) || (code ? CODE_FIELDS[code] : undefined);
};
